var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonActionModal',{attrs:{"dialog":_vm.dialogLeadEncontrado,"title":_vm.title,"subtitle":_vm.subtitle,"bottonText":"Si, abrir"},on:{"userChoice":_vm.changeRoute}})
}
var staticRenderFns = []

export { render, staticRenderFns }